import { render, staticRenderFns } from "./PrHoldOrNotSlide.vue?vue&type=template&id=593ae906&"
import script from "./PrHoldOrNotSlide.vue?vue&type=script&lang=js&"
export * from "./PrHoldOrNotSlide.vue?vue&type=script&lang=js&"
import style0 from "./PrHoldOrNotSlide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports